/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './begin.defs'
export { main as default } from './begin.defs'
